var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 46C36.0358 46 46.3333 35.7025 46.3333 23C46.3333 10.2975 36.0358 0 23.3333 0C10.6307 0 0.333252 10.2975 0.333252 23C0.333252 35.7025 10.6307 46 23.3333 46ZM31.2319 20.8508C30.1536 19.7725 28.691 19.1667 27.166 19.1667C25.641 19.1667 24.1785 19.7725 23.1002 20.8508C22.0218 21.9291 21.416 23.3917 21.416 24.9167V31.625H25.2494V24.9167C25.2494 24.4083 25.4513 23.9208 25.8108 23.5614C26.1702 23.2019 26.6577 23 27.166 23C27.6744 23 28.1619 23.2019 28.5213 23.5614C28.8808 23.9208 29.0827 24.4083 29.0827 24.9167V31.625H32.916V24.9167C32.916 23.3917 32.3102 21.9291 31.2319 20.8508ZM17.5833 31.625V20.125H13.75V31.625H17.5833ZM17.5833 15.3333C17.5833 16.3919 16.7252 17.25 15.6667 17.25C14.6081 17.25 13.75 16.3919 13.75 15.3333C13.75 14.2748 14.6081 13.4167 15.6667 13.4167C16.7252 13.4167 17.5833 14.2748 17.5833 15.3333Z",
    fill: "#1E1619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInM);
export default __webpack_public_path__ + "static/media/inM.aa7e48086768a311fd1becb8fab615a3.svg";
export { ForwardRef as ReactComponent };